import Fetch from '../../mixins/Fetch'
import Swal from 'sweetalert2'

// const deleteAllCookies = () => {
//   const cookies = document.cookie.split(';')
//
//   for (let i = 0; i < cookies.length; i++) {
//     const cookie = cookies[i]
//     const eqPos = cookie.indexOf('=')
//     const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
//     document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GM'
//   }
// }

const logout = ({ commit }) => {
  localStorage.removeItem('token')
  localStorage.removeItem('idToken')
  localStorage.removeItem('idPerfil')
  localStorage.removeItem('id')
  localStorage.removeItem('nome')
  localStorage.removeItem('rotas')
  localStorage.removeItem('descPerfil')
  commit('LOGOUT')
}

const checkToken = async ({ commit }) => {
  const request = Fetch.get('check/checkToken')

  if (request.status === 'error') throw new Error(request.message)

  request.then((e) => {
    if (e.status === 'error') {
      Swal.fire({
        icon: 'error',
        title: 'Erro!',
        html: '<p>Falha no processamento, por favor tente mais tarde.<br /> Se o problema persistir entre em contato pelo número<br /> <b>(11) 99112-1948</b></p>',
        confirmButtonText: 'Fechar'
      })
    }
  })
}

export default {
  logout,
  checkToken
}
